var r = (t, o, n) => new Promise((a, d) => {
  var u = (e) => {
    try {
      c(n.next(e));
    } catch (i) {
      d(i);
    }
  }, g = (e) => {
    try {
      c(n.throw(e));
    } catch (i) {
      d(i);
    }
  }, c = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(u, g);
  c((n = n.apply(t, o)).next());
});
import { selfAxios as s } from "@oppein/op-utils";
function h(t) {
  return r(this, null, function* () {
    const {
      data: o
    } = yield s.post(
      "/mtdsretail/productionProductShower/convertMscsContent",
      t
    );
    return o == null ? void 0 : o.data;
  });
}
function m(t) {
  return r(this, null, function* () {
    const {
      data: o
    } = yield s.get(
      "/production-order/engineering/productionProductShower/getShowerRoomModels",
      { params: t }
    );
    return o;
  });
}
function l(t) {
  return r(this, null, function* () {
    const {
      data: o
    } = yield s.get(
      "/production-order/engineering/productionProductShower/getshowerRoomModelOption",
      { params: t }
    );
    return o;
  });
}
export {
  m as getShowerRoomModels,
  l as getshowerRoomModelOption,
  h as reqConvertMscsContent
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/template/post.js
// module id = 954
// module chunks = 41